import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTabs',
  setup(__props) {

const simpleTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/simpleTabs.vue"))
const iconTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/iconTabs.vue"))
const verticalTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/verticalTabs.vue"))
const pillsTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/pillsTabs.vue"))
const justifyTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/justifyTabs.vue"))
const leftTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/leftTabs.vue"))
const materialTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/materialTabs.vue"))
const borderTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/borderTabs.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Tabs",
      title: "Bootstrap Tabs"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(simpleTabs)),
        _createVNode(_unref(iconTabs)),
        _createVNode(_unref(verticalTabs)),
        _createVNode(_unref(pillsTabs)),
        _createVNode(_unref(justifyTabs)),
        _createVNode(_unref(leftTabs)),
        _createVNode(_unref(materialTabs)),
        _createVNode(_unref(borderTabs))
      ])
    ])
  ], 64))
}
}

})